import React from 'react';

import { createReactRenderer } from 'helpers/react-renderer';
import Modules from 'root/apps/shared_modules/Modules';
import { datadogRum } from 'root/datadog/datadogRum';

import { CapitalOffer } from '../BusinessSnapshot/BusinessSnapshot.types';
import { getTrackingEnvironment } from '../tracking/getTrackingEnvironment';
import { TrackingProvider } from '../tracking/TrackingContext';
import TrackingIdentify from '../tracking/TrackingIdentify';
import { useCapitalBannerComponent } from './hooks/useCapitalBannerComponent';
import { useOfferData } from './hooks/useOfferData';

type Props = {
  capitalOffer?: CapitalOffer;
  snapshotDismissalValue?: string;
};

const CapitalBanner: React.FC<Props> = ({ capitalOffer, snapshotDismissalValue }) => {
  const offerData = useOfferData();
  const Banner = useCapitalBannerComponent(offerData);

  if (!offerData.hasBannerRights) {
    return null;
  }

  const hasReportsCapitalHeapErrorBoundary = Modules.hasModule(
    'reports.capital.heap_error_boundary'
  );

  const renderBanner = ({ withVisibilityTracker = false } = {}) => (
    <Banner
      capitalOffer={capitalOffer}
      snapshotDismissalValue={snapshotDismissalValue}
      offerData={offerData}
      withVisibilityTracker={withVisibilityTracker}
    />
  );

  return (
    <TrackingProvider
      configs={[{ name: 'product', environment: getTrackingEnvironment() }]}
      fallbackRender={() => renderBanner()}
      onInitError={(err) => datadogRum.addError(err, { context: 'tracking_module_init' })}
    >
      <TrackingIdentify />
      {renderBanner({ withVisibilityTracker: hasReportsCapitalHeapErrorBoundary })}
    </TrackingProvider>
  );
};

export default CapitalBanner;

const RenderedComponent = createReactRenderer({
  component: CapitalBanner,
  selector: '[data-react-root="CapitalBanner"]',
});

history.onChangeState(
  [{ form_name: 'ui_tab', tab: 'reports' }],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
